import React from 'react';
import StatsMenu from "components/common/statsmenu"
import StickyMenu from "components/common/stickymenu"
import MainMenu from 'components/common/mainmenu';
import ChooseLayout from './ChooseLayout'
const TopMenu = (props) => {
    return (
        <StickyMenu withStickyHeader={false}>
            <MainMenu
                overviewIsActive={false}
                comparisonIsActive={false}
                onlyLeftMenu={true}
            />
            <StatsMenu
                leftItemBold={props.pageTitle}
                leftItems={
                    <React.Fragment>
                        <span className="stats-menu__list-item  " onClick={props.onClickSave}>
                            <div className="stats-menu-btn cursor--pointer">
                                {props.onSaveDropdown}
                            </div>
                        </span>
                        <span className="stats-menu__list-item " onClick={props.onClickCancel}>
                            <div className="stats-menu-btn cursor--pointer">
                                <span className="cursor--pointer">
                                    <i className="material-icons material-icons_size cancel--icons" >cancel</i>
                                    {props.cancelBtnText}
                                </span>
                            </div>
                        </span>
                        <ChooseLayout />
                    </React.Fragment>
                }
            />
            {props.children}
        </StickyMenu>
    )
}

export default TopMenu;


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/TopMenuContainer/TopMenu.jsx